import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
const DeleteDialog = ({ confirmOpen, deleteModalRef, setConfirmOpen, handleDelete }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={confirmOpen}
      ref={deleteModalRef}
      onClose={(e) => {
        setConfirmOpen(false);
      }}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>
        <Typography
          style={{
            fontFamily: 'var(--font-main), Sans-serif, Arial'
          }}>
          {t('deleteDialog.sure')}
        </Typography>
      </DialogTitle>
      <DialogActions>
        <Button onClick={handleDelete} color='primary'>
          {t('common.delete')}
        </Button>
        <Button
          onClick={() => {
            setConfirmOpen(false);
          }}
          color='primary'>
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
